import { useState } from "react";
let fsTimeout = false;
export const useThrottle = (initalValue, timeout, func) => {
  const [value, setValue] = useState(initalValue);
  const throttledFulltext = e => {
    const text = e.target.value;
    if (fsTimeout) clearTimeout(fsTimeout);
    fsTimeout = setTimeout(() => {
      func(text);
    }, timeout);
    setValue(text);
  };

  return [value, throttledFulltext];
};
